/**
 * CountdownTimer 倒计时组件
 *
 * 展示卡券剩余有效期的倒计时组件
 *
 * Requirements 6.1, 6.2:
 * - 剩余有效期 > 1天：显示"距失效x天"格式
 * - 剩余有效期 ≤ 1天：显示"距失效hh:mm:ss"格式的实时倒计时
 * - 已过期：保持显示"距失效00:00:00"，角标不移除
 */

import React, { useEffect, useRef } from "react";
import { CountdownTimerProps } from "../../types/coupon-redemption";
import { formatCountdown } from "../../utils/coupon-redemption";
import { useServerNow } from "@/hooks/useServerTimeSync";
import { getRemainingSeconds } from "@/utils/server-time";
import "./index.less";

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  expireTime,
  onExpire,
}) => {
  const serverNow = useServerNow();
  const onExpireRef = useRef(onExpire);
  const remainingSeconds = getRemainingSeconds(expireTime, serverNow);
  const isExpired = remainingSeconds === 0;
  const displayNow = expireTime - remainingSeconds * 1000;

  useEffect(() => {
    onExpireRef.current = onExpire;
  }, [onExpire]);

  useEffect(() => {
    if (isExpired) {
      onExpireRef.current?.();
    }
  }, [expireTime, isExpired]);

  return (
    <span className="countdown-timer">
      {formatCountdown(expireTime, displayNow)}
    </span>
  );
};

export default CountdownTimer;
